<template>
    <div id="webshop" class="page">
        <h2>Webshop</h2>
        <div class="list-group">
            <div class="list-group-item list-group-item-action d-flex flex-row">
                <div class="d-flex flex-column p-2 flex-wrap align-self-center">
                    <img src="@/assets/logo-dark.png" width="100px" />
                </div>
                <div class="d-flex flex-column p-2 w-100">
                    <h5 class="mb-1">Basis Kledingpakket</h5>
                    <p class="mb-1">Het basis pakket omvat een polo, sweater en jas voorzien van het Azurity Beveiligings logo.</p>
                    <small>Voor het basispakket wordt € 150,- aan borg in rekening gebracht. Deze ontvangt u retour bij inlevering.</small>
                </div>
                <div class="d-flex flex-column p-2 flex-wrap align-self-center">
                    <a href="mailto:info@azurity.nl&subject=Bestellen Basis Kledingpakket&body=Ik zou graag het basis kledingpakket willen bestellen. Mijn gegevens zijn:" class="btn btn-azure-dark" >Bestellen</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
</style>